export function isFreedomPayIntent(id) {
  return !id?.startsWith('pi_');
}

export function isStripeIntent(id) {
  return !!id?.startsWith('pi_');
}
